import {isDevMode, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from "@angular/forms";

import {SharedModule} from "@shared/shared.module";

import { SurveyComponent } from './components/survey/survey.component';
import { StarComponent } from './components/star/star.component';
import {SurveySentComponent} from "./components/survey-sent/survey-sent.component";
import { RatingComponent } from './components/rating/rating.component';
import { ReasonsListComponent } from './components/reasons-list/reasons-list.component';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    SurveyComponent,
    StarComponent,
    SurveySentComponent,
    RatingComponent,
    ReasonsListComponent
  ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        TranslateModule
    ],
  exports: [ SurveyComponent ]
})
export class SurveyModule {
  constructor() {
    if (isDevMode())
      console.log('SurveyModule loaded');
  }
}
